import { SessionStorageKeys, StorageKeys } from "../types/enums/Storage.enum";

export const NOMBRE_INSTITUCION = 'Poder Judicial';
export const NOMBRE_CALENDARIO = 'Agenda - '+ NOMBRE_INSTITUCION;


/**
 * Utilidades para localStorage
 */
export const storage = {
  /** */
  get: (key: StorageKeys) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  },
  set: (key: StorageKeys, value: any) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Error guardando en localStorage:', error);
    }
  },
  remove: (key: StorageKeys) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removiendo datos desde localStorage:', error);
    }
  },
  clear: () => {
    try {
      /* Preservar el perfil seleccionado durante validaciones de token */
      const perfilActual = storage.get(StorageKeys.PERFIL);
      
      (Object.values(StorageKeys) as string[])
        .filter(value => typeof value === 'string')
        .forEach(key => {
          localStorage.removeItem(key);
        });
      sessionStore.clear();
      
      /* Restaurar el perfil después de la limpieza */
      if (perfilActual) {
        storage.set(StorageKeys.PERFIL, perfilActual);
      }
    } catch (error) {
      console.error('Error limpiando localStorage:', error);
    }
  },
  /**
   * Limpiar TODO el localStorage sin excepciones
   * Usar solo en logout explícito del usuario
   */
  clearAll: () => {
    try {
      (Object.values(StorageKeys) as string[])
        .filter(value => typeof value === 'string')
        .forEach(key => {
          localStorage.removeItem(key);
        });
      sessionStore.clear();
    } catch (error) {
      console.error('Error limpiando localStorage:', error);
    }
  }
};

/**
 * Utilidades para sessionStorage: los datos sobreviven a la recarga del navegador (F5)
 * pero son exclusivos de la pestaña y se descartan al cerrarla
 */
export const sessionStore = {
  get: (key: SessionStorageKeys) => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  },
  set: (key: SessionStorageKeys, value: unknown) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Error guardando en sessionStorage:', error);
    }
  },
  remove: (key: SessionStorageKeys) => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error('Error removiendo datos desde sessionStorage:', error);
    }
  },
  /** Fusiona `partialValue` con el objeto guardado (o con un objeto vacío si no existe) */
  update: (key: SessionStorageKeys, partialValue: object) => {
    sessionStore.set(key, { ...(sessionStore.get(key) || {}), ...partialValue });
  },
  clear: () => {
    Object.values(SessionStorageKeys).forEach(key => sessionStore.remove(key));
  }
};
/**
 * Opciones de paginación comunes
 */
export const LISTA_OPCIONES_PAGINACION = [5, 10, 25, 50, 100];  